<template>
  <div>
    <v-row
      key="performancePortalFilter"
      align="center"
      class="mt-0"
      dense
    >
      <v-col
        v-if="eventData.length === 0"
        class="ml-3 my-4"
      >
        <span class="text-h6">
          {{ $t("event_analysis.no_events") }}
          <v-btn
            class="ml-2 text-none"
            small
            outlined
            @click="$emit('event-selection')"
          >
            <v-icon
              x-small
              left
            >
              far fa-pen
            </v-icon>
            {{ $t("button.change_period") }}
          </v-btn>
        </span>
      </v-col>
      <v-col
        v-else-if="eventData"
      >
        <span
          class="text-h6 font-weight-medium text-none primary--text"
          style="cursor: pointer;"
          @click="$emit('event-selection')"
        >
          {{ eventData.title }}
          <v-icon
            x-small
            color="primary"
          >fa fa-chevron-down</v-icon>
        </span>
        <v-row
          align="center"
          no-gutters
        >
          <v-col cols="auto">
            {{ dayjs(eventData.start_at).format('dddd, MMMM D HH:mm') }} - {{ dayjs(eventData.end_at).format('HH:mm') }}
          </v-col>
          <v-col
            cols="auto"
            class="pl-3"
          >
            <v-chip
              label
              :color="eventTypes[eventData.event_type].color"
              dark
              small
            >
              {{ eventTypes[eventData.event_type].text }}
            </v-chip>
          </v-col>
          <v-col cols="auto">
            <v-btn
              small
              text
              color="primary"
              class="text-none"
              @click="$emit('toggle-drawer')"
            >
              {{ $t('button.view_event_details') }}
            </v-btn>
            <v-btn
              v-if="hasPeriods"
              class="text-none"
              color="primary"
              text
              small
              @click="$router.push({name: $routeNames.PERFORMANCE_PERIOD_SUMMARY, params: {id: eventData.id}})"
            >
              View period summary
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        v-if="hasPeriods || hasTrainingExercisesStartTime"
        cols="auto"
        class="text-body-2 pr-0"
      >
        <v-btn
          class="text-none mr-1"
          color="primary"
          text
          @click="$emit('period-selection')"
        >
          {{ buttonLabel }}
          <v-icon
            right
            x-small
          >
            far fa-chevron-down
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <layout-selector
          :selected-layout.sync="dirtySelectedLayout"
          :layouts.sync="dirtyLayouts"
          @add-layout="$emit('add-layout')"
          @edit-layout="$emit('edit-layout')"
        />
      </v-col>
    </v-row>
    <v-divider class="mt-3" />
    <v-alert
      v-if="eventData && eventData.waiting_for_stats"
      prominent
      text
      outlined
      color="primary"
      class="mt-6 text-body-1"
    >
      <v-progress-circular
        :size="40"
        indeterminate
        :width="2"
        class="ml-4 mr-8"
      />
      {{ $t("performance.event.waiting_for_stats") }}
    </v-alert>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import LayoutSelector from '@/components/LayoutSelector.vue'

export default {
  name: 'PerformanceHeader',
  components: { LayoutSelector },
  props: {
    eventData: {
      type: Object,
      default: () => ({})
    },
    eventTypes: {
      type: Object,
      required: true
    },
    hasPeriods: {
      type: Boolean,
      default: false
    },
    hasTrainingExercisesStartTime: {
      type: Boolean,
      default: false
    },
    buttonLabel: {
      type: String,
      default: ''
    },
    isIndividual: {
      type: Boolean,
      default: false
    },
    layouts: {
      type: Array,
      required: true
    },
    selectedLayout: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
    dirtySelectedLayout: {
      get() {
        return this.selectedLayout
      },
      set(value) {
        this.$emit('update:selectedLayout', value)
      }
    },
    dirtyLayouts: {
      get() {
        return this.layouts
      },
      set(value) {
        this.$emit('update:layouts', value)
      }
    }
  },
  watch: {
  },
  methods: {
    dayjs
  }
}
</script>
